import {
  type StudentGradeDetailViewModel,
  useGetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail,
} from '@/shared/api/generated';

/**
 * Detalhe de notas e frequência de um aluno pela sua matrícula (`courseRegistrationId`).
 *
 * Wrapper fino sobre o hook gerado pelo Kubb do endpoint
 * `GET grade-and-frequence/course-registrations/{id}/grade-detail`. A query só dispara
 * quando há um `courseRegistrationId` válido (> 0) — antes disso fica ociosa.
 *
 * @param courseRegistrationId - Id da matrícula do aluno; `0`/ausente desabilita a busca.
 * @returns Detalhe do aluno com estado de carga/erro e `refetch`.
 *
 * @example
 * ```tsx
 * const { detail, isLoading } = useStudentGradeDetail(matriculaId);
 * ```
 */
export function useStudentGradeDetail(courseRegistrationId: number) {
  const enabled = Number.isFinite(courseRegistrationId) && courseRegistrationId > 0;

  const { data, isLoading, isError, refetch, isFetching } =
    useGetApiV1ClassroomdisciplineGradeAndFrequenceCourseRegistrationsCourseregistrationidGradeDetail(
      courseRegistrationId,
      { query: { enabled } },
    );

  return {
    detail: data as StudentGradeDetailViewModel | undefined,
    isLoading: enabled && isLoading,
    isFetching,
    isError,
    refetch,
  } as const;
}
